"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenu = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _Drawer = require("../Drawer");

var _Search = require("../Search");

var _menus = require("./menus");

var _StackedNav = require("../StackedNav");

var _IconButton = require("../IconButton");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var GlobalSearch = ( /*#__PURE__*/0, _theming.styled)(_Search.Search, process.env.NODE_ENV === "production" ? {
  target: "e19vqvl0"
} : {
  target: "e19vqvl0",
  label: "GlobalSearch"
})(process.env.NODE_ENV === "production" ? {
  name: "1fgdcyd",
  styles: "margin-bottom:24px"
} : {
  name: "1fgdcyd",
  styles: "margin-bottom:24px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var MobileMenu = function MobileMenu(_ref) {
  var className = _ref.className,
      navLinks = _ref.navLinks,
      inverse = _ref.inverse,
      monochrome = _ref.monochrome,
      version = _ref.version,
      apiKey = _ref.apiKey;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var mobileGroupsWithLinks = (0, _react.useMemo)(function () {
    return (0, _menus.mobileGroups)(navLinks);
  }, [navLinks]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    inverse: inverse,
    monochrome: monochrome,
    "aria-label": "Open site nav",
    onClick: function onClick() {
      return setOpen(true);
    },
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    icon: "menualt"
  })), /*#__PURE__*/_react["default"].createElement(_Drawer.Drawer, {
    open: open,
    setOpen: setOpen,
    label: "nav links"
  }, /*#__PURE__*/_react["default"].createElement(GlobalSearch, {
    apiKey: apiKey,
    version: version
  }), mobileGroupsWithLinks.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement(_StackedNav.StackedNav, {
      key: group.label,
      label: group.label
    }, group.items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_StackedNav.StackedNavItem, {
        key: item.label,
        icon: item.icon,
        href: item.link.url,
        LinkWrapper: item.link.linkWrapper,
        onClick: function onClick() {
          setOpen(false);
        }
      }, item.label);
    }));
  })));
};

exports.MobileMenu = MobileMenu;